<template>
  <div id="teams-list-table">
    <v-data-table
      :headers="tableHeaders"
      :loading="loading"
      :items="teams"
      hide-default-footer
      :items-per-page="pagination.per_page"
    >
      <!--<editor-fold desc="ITEM SLOT">-->
      <template v-slot:item="{ item }">
        <teams-list-table-row
          v-if="!loading"
          :team="item"
          @edit="onEditTeam"
        />
      </template>
      <!--</editor-fold>-->
      <!--<editor-fold desc="PROGRESS SLOT">-->
      <template slot="progress">
        <!-- override default progress bar -->
        <div
          class="pa-5 d-flex justify-center align-center"
          :style="'min-height: ' + (teams.length * 49)+'px'"
        >
          <v-progress-circular
            indeterminate
            size="48"
            width="4"
            color="grey lighten-2"
          />
        </div>
      </template>
      <!--</editor-fold>-->
    </v-data-table>
    <div
      v-if="pagination && pagination.last_page > 1"
      class="d-flex justify-center align-center py-5"
    >
      <pagination
        v-model="pagination.current_page"
        :last-page="pagination.last_page"
      />
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue'
import TeamsListTableRow from '@/components/teams/TeamsListTableRow.vue'
import { EventBus } from '@/plugins/bus'

export default {
  name: 'TeamsListTable',
  components: { TeamsListTableRow, Pagination },
  props: {
    teams: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    pagination: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    editTeam: {
      team: undefined,
      visible: false
    }
  }),
  computed: {
    tableHeaders() {
      return [
        { key: 'name', align: 'start', text: this.$t('dropdown.team.title'), sortable: false },
        { key: 'coachName', text: this.$t('table_headers.admin_all_teams.coach'), sortable: false },
        { key: 'playersCount', text: this.$t('dropdown.players.title'), sortable: false },
        { key: 'actions', width: '1%', align: 'end', text: '', sortable: false }
      ]
    }
  },
  methods: {
    onEditTeam(team) {
      EventBus.$emit(this.$events.EDIT_TEAM, team)
    }
  }
}
</script>
